import StartEventHook from './StartEventHook'
import { bidderForCode } from '../utils'
import FillManager from '../FillManager'
import { UdmFillMethod } from '../fillers/UdmFillMethod'
import Logger from '../Log'

const Log = Logger.for('UdmStartHook')

export default class UdmStartHook extends StartEventHook {
  constructor () {
    super('UdmStartHook')
  }

  run (remoteConfig) {
    return new Promise((resolve, reject) => {
      const bidder = bidderForCode('udm', remoteConfig.bidders(), true)

      if (!bidder) {
        return resolve()
      }

      let bs
      if (Array.isArray(bidder)) {
        bs = bidder
      } else {
        bs = [bidder]
      }

      bs.forEach(b => {
        FillManager.register(new UdmFillMethod(b))
        Log.debug('Registered udm fill method')
      })

      resolve()
    })
  }
}
